// extracted by mini-css-extract-plugin
export default {"referral":"Referral_referral__0Ckfk","container":"Referral_container__WNpm5","label":"Referral_label__QFPXX"};